/* ─── Configuración del portal de clientes ───────────────────────────────
   Estos valores apuntan a los datos que llegan desde el sistema de control de
   Aya (otra web) y se sincronizan en Firestore.

   ⚠️  AJUSTAR cuando se defina la estructura definitiva de los datos:
   - CLIENT_PROJECTS_COLLECTION: nombre de la colección de Firestore con los
     proyectos de los clientes.
   - CLIENT_EMAIL_FIELD: campo del documento que vincula cada proyecto con el
     correo del cliente (se compara en minúsculas).
*/
export const CLIENT_PROJECTS_COLLECTION = "clientProjects";
export const CLIENT_EMAIL_FIELD = "clientEmail";

/* Colección de la allowlist de clientes (gestionada desde el panel admin).
   Cada documento: { email, name, company, active, createdAt }. */
export const CLIENTS_COLLECTION = "clients";
